import React from 'react';
import { MenuList, MenuItem } from '@mui/material';
import {
	GridColumnMenuContainer,
	SortGridMenuItems,
	GridFilterMenuItem,
	HideGridColMenuItem,
	GridColumnsMenuItem,
	GridColumnMenuProps,
} from '@mui/x-data-grid-pro';
import { useTranslation } from 'services/localization';

interface CustomColumnMenuProps extends GridColumnMenuProps {
	dynamicColumns: string[];
	openRenameColumnDialog: (id: string) => void;
	openDeleteColumnDialog: (id: string) => void;
	moveColumn: (id: string, direction: 1 | -1) => void;
}

const CustomColumnMenu = (props: CustomColumnMenuProps) => {
	const { t } = useTranslation();
	const {
		hideMenu,
		currentColumn,
		dynamicColumns,
		openRenameColumnDialog,
		openDeleteColumnDialog,
		moveColumn,
	} = props;

	const { field: columnId } = currentColumn;
	const isEditable = dynamicColumns.includes(columnId);
	const dynamicColumnIdx = dynamicColumns.findIndex((id) => id === columnId);
	const canBeMovedLeft = dynamicColumnIdx > 0;
	const canBeMovedRight = dynamicColumnIdx < dynamicColumns.length - 1;

	return (
		<GridColumnMenuContainer {...props}>
			<SortGridMenuItems onClick={hideMenu} column={currentColumn!} />
			<GridFilterMenuItem onClick={hideMenu} column={currentColumn!} />
			<HideGridColMenuItem onClick={hideMenu} column={currentColumn!} />
			<GridColumnsMenuItem onClick={hideMenu} column={currentColumn!} />
			{isEditable && (
				<MenuList>
					<MenuItem onClick={() => openRenameColumnDialog(columnId)}>
						{t('inventory.columnsRenameAction', 'Rename')}
					</MenuItem>
					<MenuItem onClick={() => openDeleteColumnDialog(columnId)}>
						{t('common:actions.delete')}
					</MenuItem>
					<MenuItem onClick={() => moveColumn(columnId, -1)} disabled={!canBeMovedLeft}>
						{t('inventory.columnsEditMoveLeft', 'Move left')}
					</MenuItem>
					<MenuItem onClick={() => moveColumn(columnId, 1)} disabled={!canBeMovedRight}>
						{t('inventory.columnsEditMoveRight', 'Move right')}
					</MenuItem>
				</MenuList>
			)}
		</GridColumnMenuContainer>
	);
};

export default CustomColumnMenu;
